export class AIACommand {
    constructor(keycloak, action, redirectUrl) {
        this.keycloak = keycloak;
        this.action = action;
        this.redirectUrl = redirectUrl;
    }
    execute() {
        this.keycloak.login({
            action: this.action,
            redirectUri: this.redirectUrl
        });
    }
}
